import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { NgCreditCardComponent } from "./ng-credit-card.component";

@NgModule({
    declarations: [NgCreditCardComponent],
    imports: [CommonModule, HttpClientModule],
    exports: [NgCreditCardComponent]
})
export class NgCreditCardModule {}
